import React from 'react';

const Terms = () => {
    return (
        <div style={{ minHeight: '100vh', backgroundColor: '#f3f4f6', color: '#1f2937', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
            {/* The Main Content Card */}
            <div style={{ 
                maxWidth: '800px', 
                margin: '40px auto', 
                padding: '40px', 
                backgroundColor: '#ffffff', 
                borderRadius: '12px', 
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                lineHeight: '1.7'
            }}>
                <h1 style={{ color: '#2563eb', borderBottom: '2px solid #e5e7eb', paddingBottom: '15px', marginTop: '0' }}>
                    Terms of Use & Privacy Policy
                </h1>
                
                <p style={{ fontStyle: 'italic', color: '#6b7280', marginBottom: '30px' }}>
                    Last Updated: March 2026
                </p>
                
                <p style={{ color: '#4b5563' }}>
                    Welcome to Tournament Master ("we," "our," or "the App"). By registering an account, you agree to the following terms.
                </p>

                <h2 style={{ color: '#1f2937', marginTop: '30px' }}>1. Beta Software Disclaimer</h2>
                <p style={{ color: '#4b5563' }}>
                    Tournament Master is currently in a "Beta" testing phase. The platform is provided "as is" and "as available." We do not guarantee that the service will be uninterrupted or error-free.
                </p>

                <h2 style={{ color: '#1f2937', marginTop: '30px' }}>2. User Accounts & Security</h2>
                <ul style={{ color: '#4b5563', paddingLeft: '20px' }}>
                    <li style={{ marginBottom: '10px' }}>You are responsible for maintaining the confidentiality of your password.</li>
                    <li style={{ marginBottom: '10px' }}>You agree to provide a valid email address for account verification.</li>
                    <li style={{ marginBottom: '10px' }}>We reserve the right to suspend accounts that engage in abusive behavior or spam.</li>
                </ul>

                <h2 style={{ color: '#1f2937', marginTop: '30px' }}>3. Privacy & Data Usage</h2>
                <ul style={{ color: '#4b5563', paddingLeft: '20px' }}>
                    <li style={{ marginBottom: '10px' }}><strong>Emails:</strong> Used solely for account verification and critical notifications. We will never sell your email.</li>
                    <li style={{ marginBottom: '10px' }}><strong>Passwords:</strong> Hashed and encrypted. We cannot see your actual password.</li>
                    <li style={{ marginBottom: '10px' }}><strong>Cookies:</strong> We use strictly necessary tokens to keep you logged in securely.</li>
                </ul>

                <h2 style={{ color: '#1f2937', marginTop: '30px' }}>4. User-Generated Content</h2>
                <p style={{ color: '#4b5563' }}>
                    Any tournaments or scores you create belong to you, but you grant us the right to display them on the platform. Please do not use inappropriate or offensive names.
                </p>
            </div>
        </div>
    );
};

export default Terms;